enum Tile {
    Empty,
    X,
    O
}

export default Tile;
